import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import * as firebase from 'firebase';
import { UserService } from '../../service/user.service';
import { NgForm } from '@angular/forms';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-obavestenja',
  templateUrl: './obavestenja.component.html',
  styleUrls: ['./obavestenja.component.css']
})
export class ObavestenjaComponent implements OnInit, AfterViewInit {
  users: any = [];
  user: any;
  doktori: any = [];
  istorija: any = [];
  istorijaBroj: any = [];
  statistika: any = [];
  static: any = [];
  novaIstorija: any = [];
  naplataArr: any = [];
  doktorArr: any = [];
  sabrano: Number;
  sabranoDr: Number;
  doktorBool = false;
  datumBool = false;
  imeDoktora: any = '';
  datumOdbind: any = '';
  datumDobind: any = '';
  chart: Array<any> = [];
  chartData: Array<any> = [];
  @ViewChild('myChart') el: ElementRef;
  constructor(private userService: UserService) {
    this.user = this.userService.getProfile();
    this.users = firebase
      .database()
      .ref()
      .child('users/');
    this.istorija = firebase.database().ref('pacijenti/');
    this.statistika = firebase.database().ref('/naplataDr/');
  }

  ngAfterViewInit() {}
  ngOnInit() {
    this.users.on('child_added', data => {
      this.doktori.push({
        key: data.key,
        data: data.val()
      });
    });

    this.istorija.on('child_added', data => {
      this.istorijaBroj.push({
        key: data.key,
        data: data.val()
      });
    });
    this.statistika.on('child_added', data => {
      this.static.push({
        key: data.key,
        data: data.val()
      });
    });
  }
  traziPoDatumu(form: NgForm) {
    this.naplataArr = [];
    this.sabrano = 0;
    const datumOd = new Date(form.value.datumOd).valueOf();
    const datumDo = new Date(form.value.datumDo).valueOf();
    if (!datumDo || !datumOd) {
      return false;
    }
    firebase
      .database()
      .ref('/naplata/')
      .orderByChild('datum')
      .startAt(datumOd)
      .endAt(datumDo)
      .on('child_added', data => {
        this.naplataArr.push({
          key: data.key,
          data: data.val()
        });

        // this.chartData.push(data.val());
        // const datumChart = this.chartData.map(i => {
        //   return new Date(i.datum).toLocaleDateString();
        // });
        // const naplataChart = this.chartData.map(i => {
        //   return i.naplata;
        // });

        // this.chart = new Chart('canvas', {
        //   type: 'line',
        //   data: {
        //     labels: datumChart.sort(),
        //     datasets: [
        //       {
        //         data: naplataChart,
        //         borderColor: 'green'
        //       }
        //     ]
        //   },
        //   options: {
        //     legend: {
        //       display: false
        //     },
        //     tooltips: { enabled: false },

        //     scales: {
        //       xAxes: [
        //         {
        //           display: true
        //         }
        //       ],
        //       yAxes: [
        //         {
        //           display: true
        //         }
        //       ]
        //     }
        //   }
        // });
        this.naplataArr.sort(
          (a, b) =>
            new Date(a.data.datum).valueOf() - new Date(b.data.datum).valueOf()
        );
        this.sabrano = this.naplataArr.reduce((a, b) => {
          return Number(a) + Number(b.data.naplata);
        }, 0);
      });
  }
  traziPoDoktoru(form: NgForm) {
    this.doktorArr = [];
    this.naplataArr = [];
    this.sabranoDr = 0;
    const datumOd = new Date(form.value.datumOd).valueOf();
    const datumDo = new Date(form.value.datumDo).valueOf();
    const doktorSelect = form.value.doktorSelect;

    if (!datumDo || !datumOd || !doktorSelect) {
      return false;
    }
    firebase
      .database()
      .ref('/naplataDr/' + doktorSelect)
      .orderByChild('datum')
      .startAt(datumOd)
      .endAt(datumDo)
      .on('child_added', data => {
        this.doktorArr.push({
          key: data.key,
          data: data.val()
        });
        this.doktorArr.sort(
          (a, b) =>
            new Date(a.data.datum).valueOf() - new Date(b.data.datum).valueOf()
        );
        this.sabranoDr = this.doktorArr.reduce((a, b) => {
          return Number(a) + Number(b.data.naplata);
        }, 0);
      });
  }
  doktorBoole() {
    this.datumOdbind = '';
    this.datumDobind = '';
    this.doktorBool = true;
    this.datumBool = false;
    this.doktorArr = [];
    this.sabranoDr = 0;
  }
  datumBoole() {
    this.datumOdbind = '';
    this.datumDobind = '';
    this.doktorBool = false;
    this.datumBool = true;
    this.naplataArr = [];
    this.sabrano = 0;
  }
  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open(
      '',
      '_blank',
      'top=0,left=0,height=595px,width=842px'
    );
    popupWin.document.open();
    popupWin.document.write(
      '<link rel="stylesheet" href="../../assets/print.css" type="text/css" />',
      '<meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1" /> '
    );
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>

          <style type="text/css" media="all">

          </style>

        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
